import React from "react";

const Glance = () => {
    return (
        <div className="course-structure glance-sec">
            <div className="course-structure__content">
                <h2 className="title">دوره در یک نگاه</h2>
                <br/>
                <div className="row">
                    <div className="col-xs-12">
                        <img
                            className="course-structure__image"
                            src="/images/glance.png"
                            alt="derayat mba road map"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Glance;
